import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState, Suspense } from 'react';
import { useTrelloCard } from './use-trello-card';
var TrelloPopperAsync = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/trello/trello-hover-previews/trello-popper" */'./trello-popper').then(function (_ref) {
    var TrelloPopper = _ref.TrelloPopper;
    return {
      default: TrelloPopper
    };
  });
});
export var HoverPreviewsResultWrapper = function HoverPreviewsResultWrapper(_ref2) {
  var id = _ref2.id,
    title = _ref2.title,
    prefs = _ref2.prefs,
    meta = _ref2.meta,
    additionalMeta = _ref2.additionalMeta,
    closed = _ref2.closed,
    type = _ref2.type,
    children = _ref2.children,
    isColorBlindModeEnabled = _ref2.isColorBlindModeEnabled,
    isPreviewOnTrelloSearchResultsEnabled = _ref2.isPreviewOnTrelloSearchResultsEnabled,
    screen = _ref2.screen;
  var _useTrelloCard = useTrelloCard(),
    getCard = _useTrelloCard.getCard;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var onFetchCard = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var card;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getCard(id);
        case 2:
          card = _context.sent;
          if (card) {
            setResult(_objectSpread(_objectSpread({}, card), {}, {
              type: 'card',
              id: id,
              title: title,
              closed: closed,
              meta: meta,
              additionalMeta: additionalMeta,
              screen: screen
            }));
          }
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [getCard, id, title, closed, meta, screen, additionalMeta]);
  var onFetchBoard = useCallback(function () {
    if (prefs) {
      setResult({
        type: 'board',
        id: id,
        title: title,
        prefs: prefs,
        meta: meta,
        closed: closed,
        screen: screen
      });
    }
  }, [id, title, prefs, meta, closed, screen]);
  if (!isPreviewOnTrelloSearchResultsEnabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(TrelloPopperAsync, {
    type: type,
    result: result,
    onFetchCard: onFetchCard,
    onFetchBoard: onFetchBoard,
    isColorBlindModeEnabled: isColorBlindModeEnabled,
    screen: screen
  }, children));
};